import React from 'react';
import { OfferSelector } from './OfferSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function Pricing() {
  return <section id="pricing" className="py-12 md:py-24 bg-white" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="text-center max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-168">
          <h2 className="text-xs md:text-sm font-bold text-brand-gold uppercase tracking-widest mb-2 md:mb-3" data-id="element-169">
            Elegí tu Sistema
          </h2>
          <h3 className="text-2xl md:text-4xl font-serif font-bold text-brand-navy mb-2 md:mb-4" data-id="element-170">
            Empezá a implementarlo esta semana
          </h3>
          <p className="text-sm md:text-lg text-slate-600" data-id="element-171">
            Elegí una opción y accedé al material en minutos.
          </p>
        </div>

        <UrgencyBanner data-id="element-172" />

        <OfferSelector idPrefix="main" data-id="element-173" />

        <div className="mt-8 md:mt-12 max-w-3xl mx-auto bg-brand-light rounded-2xl p-5 md:p-8 text-center border border-slate-200" data-id="element-174">
          <h4 className="text-lg md:text-xl font-bold text-brand-navy mb-2 md:mb-4" data-id="element-175">
            7 DÍAS DE GARANTÍA TOTAL
          </h4>
          <p className="text-sm md:text-base text-slate-600" data-id="element-176">
            Probalo o te devolvemos el 100%. Sin preguntas, sin formularios, sin
            drama.
          </p>
        </div>
      </div>
    </section>;
}